export const locale = {
  lang: 'en-CA',
  data: {
    UPGRADE_PANEL: {
      PRO_BADGE: 'PRO',
      ORDER: 'Order',
      LEARN_MORE: 'Learn more',
      CLOSE: 'Close',
      COMING_SOON: 'coming soon',
      HOW_IT_WORKS: 'How it works',
      FEATURES: {
        TITLE: 'Features',
        TAGLINE:
          'Everything the PRO plan adds to your Caterer Manager, in one place.',
        INTRO:
          'The PRO plan brings together the modules that save your team time and win your business clients: Web Submissions, Automations, Integrations, a richer Performance dashboard and, soon, a CRM.',
        BENEFITS: {
          SUBMISSIONS: {
            TITLE: 'Web Submissions',
            TEXT: 'Your clients request a quote from your online store around the clock; the request lands complete in Caterer Manager and becomes a proposal or an order in one click.',
          },
          AUTOMATIONS: {
            TITLE: 'Automations',
            TEXT: 'Your reports generated and delivered automatically, by e-mail, to Google Drive or Microsoft OneDrive, at the frequency you set, plus an external API to connect your own tools.',
          },
          INTEGRATIONS: {
            TITLE: 'Integrations',
            TEXT: 'Zapier, QuickBooks Online, Google Drive and Google Calendar, Microsoft OneDrive and Outlook Calendar: your apps talk to Caterer Manager, with no double entry.',
          },
          KPI: {
            TITLE: 'Performance dashboard, PRO edition',
            TEXT: 'Finer indicators: sales and conversion rate by advisor, by event type and by period, year-over-year comparisons. Steer your sales with precision, not gut feeling.',
          },
          CRM: {
            TITLE: 'CRM module (coming soon)',
            TEXT: 'Track your prospects, follow-ups and business opportunities directly in Caterer Manager, linked to your clients and events.',
          },
        },
        STEPS: {
          S1: 'Explore each module of this menu: Web Submissions, Automations, Integrations.',
          S2: 'Click “Order” and tell us what you are interested in.',
          S3: 'Our team activates the PRO plan and guides you through the setup.',
        },
        PUNCH:
          'One plan, all the tools: go PRO and let your team focus on your clients.',
      },
      SUBMISSIONS: {
        TITLE: 'Web Submissions',
        TAGLINE:
          'Turn every visitor of your online store into a quote request, and every request into an event, in one click.',
        INTRO:
          'Your clients request a quote directly from your online store, around the clock. No more lost e-mails or retyping: the request lands complete in Caterer Manager, ready to become a proposal or an order.',
        BENEFITS: {
          FORM: {
            TITLE: 'A professional form, on your store',
            TEXT: 'Contact details, service type (catering, lunch box, cocktail, buffet…), date, guest count and message: everything you need to quote without calling the client back.',
          },
          NO_RETYPING: {
            TITLE: 'Zero retyping',
            TEXT: 'Every request shows up in the Web Submissions section, with a “to process” badge in your menu. An existing client is recognized by e-mail; otherwise their record is created in one click.',
          },
          ONE_CLICK: {
            TITLE: 'From request to event in one click',
            TEXT: 'Convert into a proposal or an order: the event, client, date, time, guest count and general note are pre-filled with the form content.',
          },
          INSTANT_REPLY: {
            TITLE: 'An instant reply, in your own voice',
            TEXT: 'The visitor immediately receives a customizable thank-you e-mail (Settings → Messages), and your team is notified right away.',
          },
          NOTHING_LOST: {
            TITLE: 'Nothing gets lost',
            TEXT: 'Archive, find and reopen requests; every conversion is traced in the client’s and the event’s history.',
          },
        },
        STEPS: {
          S1: 'The visitor fills in the “Quote request” form of your online store.',
          S2: 'You receive the request in Caterer Manager: badge in the menu and e-mail to your team.',
          S3: 'You convert it into a proposal or an order. The client has already received your thank-you.',
        },
        PUNCH:
          'Reply faster than your competitors: the first quote received is often the one that wins.',
      },
      AUTOMATIONS: {
        TITLE: 'Automations',
        TAGLINE:
          'Let Caterer Manager work while you sleep: the right reports, to the right people, at the right time.',
        INTRO:
          'Schedule once, receive forever. The Automations module generates your reports and delivers them, by e-mail, to Google Drive or to Microsoft OneDrive, on the schedule you set, and opens your data to your own tools through the external API.',
        BENEFITS: {
          SCHEDULED_REPORTS: {
            TITLE: 'Your reports, delivered without a thought',
            TEXT: 'Today’s event list, production sheet, deliveries… Pick the report, the frequency (daily, weekly, monthly) and the time: it goes out on the dot, in your time zone, holidays included.',
          },
          RIGHT_PERIOD: {
            TITLE: 'The right period, recalculated every time',
            TEXT: 'Today, tomorrow or the next N days: the date window is recomputed at every run. Monday morning’s report always covers the right week.',
          },
          EMAIL_OR_DRIVE: {
            TITLE:
              'By e-mail, or straight into Google Drive or Microsoft OneDrive',
            TEXT: 'PDF or Excel attached for the recipients you choose (to, cc, bcc), or filed automatically in Google Drive or Microsoft OneDrive, by report and by month. In Google Drive, an Excel file becomes a Google Sheet ready to filter.',
          },
          EXTERNAL_API: {
            TITLE: 'An external API for your own tools',
            TEXT: 'Connect your website, your ERP or your dashboards to Caterer Manager data with secure access limited to what you allow, plus PDF reports generated on demand.',
          },
          IN_CONTROL: {
            TITLE: 'Always in control',
            TEXT: '“Run now” to validate a send, status and details of the last run at a glance, enable or pause in one click.',
          },
          WEBHOOKS_MCP: {
            TITLE: 'Webhooks and MCP (coming soon)',
            TEXT: 'Push an event to your tools the moment it happens and connect Caterer Manager to your AI assistant.',
          },
        },
        STEPS: {
          S1: 'Pick the report, the frequency and the send time.',
          S2: 'Set the covered period and the destination: e-mail recipients, a Google Drive or a Microsoft OneDrive folder.',
          S3: 'Caterer Manager generates and delivers the report at every due time; you follow the status in Settings → Automation.',
        },
        PUNCH:
          'Every morning, your kitchen, your drivers and your managers already have their report in hand, without anyone clicking.',
      },
      INTEGRATIONS: {
        TITLE: 'Integrations',
        TAGLINE:
          'Your favourite tools, finally connected to your catering business: no more double entry, no more copy-paste.',
        INTRO:
          'Accounting, calendars, files, automation: Caterer Manager talks to the apps your team already uses. Data flows on its own and stays up to date, with no effort on your side.',
        BENEFITS: {
          ZAPIER: {
            TITLE: 'Zapier: 10,000+ apps one Zap away',
            TEXT: 'As soon as a client, an event or an invoice is created in Caterer Manager, trigger your automations in Slack, Google Sheets, your CRM, your e-mail tool… without a line of code. * Custom development may be required.',
          },
          QBO: {
            TITLE: 'QuickBooks Online: your books up to date, no retyping',
            TEXT: 'Send your clients, invoices and payments to QuickBooks Online straight from Caterer Manager. Your accountant works on accurate numbers, you save hours every month.',
          },
          GOOGLE: {
            TITLE: 'Google Drive and Google Calendar',
            TEXT: 'Your reports file themselves in Google Drive, in the folder you choose. Your events, deliveries, staff assignments, rooms and birthdays show up in Google calendars you can share with the whole team, on every device.',
          },
          MICROSOFT: {
            TITLE: 'Microsoft OneDrive and Outlook Calendar',
            TEXT: 'The same for the Microsoft world: reports sent to OneDrive, calendars synced into Outlook. Sign in with your Microsoft account, no extra password.',
          },
          SECURE: {
            TITLE: 'One secure, revocable connection per organization',
            TEXT: 'Every integration is authorized with your company’s official account (OAuth): no stored password, access limited to the strict minimum, and a one-click disconnect from Settings → Integrations.',
          },
          SOON: {
            TITLE: 'Coming soon: Mailchimp and Webex',
            TEXT: 'Feed your Mailchimp campaigns with your client lists, and see the client’s record pop up the moment they call you with Webex.',
          },
        },
        STEPS: {
          S1: 'In Settings → Integrations, connect your Google, Microsoft, QuickBooks or Zapier account in a few clicks.',
          S2: 'Choose what flows: reports, calendars, clients, invoices, events.',
          S3: 'Caterer Manager keeps everything in sync; you stay in control and can disconnect at any time.',
        },
        PUNCH:
          'Every integration saves you hours a week: connect one today, and let the rest follow.',
      },
      AI: {
        TITLE: 'AI',
        INTRO:
          'Artificial intelligence for your catering business. Coming soon.',
      },
    },
  },
};
